module.exports = __webpack_public_path__ + "method2.png?aecd649ea949f59ee1ba583eb2d6fea0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/method2.png
// module id = 24
// module chunks = 0